<div class="admin-panel-applications">
  <h1 class="mb-4">Zarządzanie wnioskami</h1>

  <div class="wide">
    <p-table
      #table
      (onSort)="onPrimeSortChange($event)"
      [lazy]="true"
      [loading]="isDataLoading()"
      [rows]="tablePage()?.size || 10"
      [scrollable]="true"
      scrollHeight="flex"
      [tableStyle]="{ 'min-width': '50rem' }"
      [totalRecords]="tablePage()?.totalElements || 0"
      [value]="rows()"
      dataKey="id"
    >
      <ng-template #header>
        <tr>
          <th pSortableColumn="kod" class="w-38">
            <div class="flex items-center gap-2">
              Kod wniosku
              <p-sortIcon field="kod" />
            </div>
          </th>
          <th pSortableColumn="nazwa" class="min-w-72">
            <div class="flex items-center gap-2">
              Nazwa
              <p-sortIcon field="nazwa" />
            </div>
          </th>
          <th pSortableColumn="grupa">
            <div class="flex items-center gap-2">
              Grupa
              <p-sortIcon field="grupa" />
            </div>
          </th>
          <th pSortableColumn="usuniety">
            <div class="flex items-center gap-2 whitespace-nowrap">
              Wniosek usunięty
              <p-sortIcon field="usuniety" />
            </div>
          </th>
          <th>Akcje</th>
        </tr>
        <tr>
          <td class="table-filter-cell w-38">
            <div class="filter-cell-content">
              <input
                (change)="onPrimeFilterChange($event.target, 'kod')"
                aria-label="Filtruj po kodzie"
                pInputText
                class="w-full"
                [(ngModel)]="tableFilters.kod"
              />
            </div>
          </td>
          <td class="table-filter-cell min-w-72">
            <div class="filter-cell-content">
              <input
                (change)="onPrimeFilterChange($event.target, 'nazwa')"
                aria-label="Filtruj po nazwie"
                pInputText
                class="w-full"
                [(ngModel)]="tableFilters.nazwa"
              />
            </div>
          </td>
          <td class="table-filter-cell">
            <div class="filter-cell-content">
              <p-select
                (onChange)="onPrimeFilterChange($event.value, 'grupa')"
                [options]="areaOptions"
                [showClear]="true"
                [(ngModel)]="tableFilters.grupa"
                optionLabel="label"
                optionValue="value"
                placeholder="Wybierz grupę"
                appendTo="body"
                class="w-full"
                ariaLabel="Filtruj po obszarze"
              ></p-select>
            </div>
          </td>
          <td class="table-filter-cell">
            <div class="filter-cell-content">
              <p-select
                (onChange)="onPrimeFilterChange($event.value, 'usuniety')"
                [options]="deletedOptions"
                [showClear]="true"
                [(ngModel)]="tableFilters.usuniety"
                optionLabel="label"
                optionValue="value"
                placeholder="Wybierz wartość"
                appendTo="body"
                class="w-full"
                ariaLabel="Filtruj czy usunięto"
              ></p-select>
            </div>
          </td>
          <td class="table-filter-cell actions-filter-cell"></td>
        </tr>
      </ng-template>
      <ng-template #body let-applicationForm>
        <tr>
          <td class="w-32">{{ applicationForm.kod }}</td>
          <td class="min-w-72">{{ applicationForm.nazwa }}</td>
          <td>
            {{
              applicationForm.grupa | constLabelReader: APPLICATION_GROUP_LABELS
            }}
          </td>
          <td>{{ getBooleanLabel(applicationForm.usuniety) }}</td>
          <td class="h-16 align-middle">
            <div class="flex items-center h-full justify-center">
              <p-button
                type="button"
                (click)="showDetails(applicationForm)"
                ariaLabel="Zobacz szczegóły"
                pTooltip="Zobacz szczegóły"
                tooltipPosition="top"
                [rounded]="true"
                [text]="true"
              >
                <i class="pi pi-eye icon" aria-hidden="true"></i>
              </p-button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template #emptymessage>
        <tr>
          <td colspan="5">Brak danych</td>
        </tr>
      </ng-template>
    </p-table>

    <div
      class="mt-4 flex flex-col items-start gap-4 md:flex-row md:items-center md:justify-end"
    >
      <div class="flex items-center gap-4">
        <p-paginator
          (onPageChange)="onPrimePageChange($event)"
          [rowsPerPageOptions]="[5, 10, 25]"
          [rows]="tablePage()?.size || 10"
          [totalRecords]="tablePage()?.totalElements || 0"
          pageLinkSize="3"
          class="customPrimePaginator"
        />
        <div class="text-sm text-nowrap">
          <span>
            Strona {{ (tablePage()?.number || 0) + 1 }} z
            {{ tablePage()?.totalPages || 0 }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="narrow">
    <p-card class="mb-4">
      <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-2">
          <label for="codeMobile" class="font-bold">Kod wniosku</label>
          <input
            id="codeMobile"
            (input)="onPrimeFilterChangeMobile($event.target, 'kod')"
            pInputText
            class="w-full"
            [(ngModel)]="tableFilters.kod"
          />
        </div>

        <div class="flex flex-col gap-2">
          <label for="nameMobile" class="font-bold">Nazwa</label>
          <input
            id="nameMobile"
            (input)="onPrimeFilterChangeMobile($event.target, 'nazwa')"
            pInputText
            class="w-full"
            [(ngModel)]="tableFilters.nazwa"
          />
        </div>

        <div class="flex flex-col gap-2">
          <span class="font-bold" id="areaMobileLabel">Obszar</span>
          <p-select
            ariaLabelledBy="areaMobileLabel"
            (onChange)="
              onPrimeFilterChangeMobile($event.value, 'grupa')
            "
            [options]="areaOptions"
            [showClear]="true"
            [(ngModel)]="tableFilters.grupa"
            optionLabel="label"
            optionValue="value"
            placeholder="Wybierz grupę"
            appendTo="body"
            class="w-full"
          ></p-select>
        </div>

        <div class="flex flex-col gap-2">
          <span class="font-bold" id="deletedMobileLabel"
            >Wniosek usunięty</span
          >
          <p-select
            ariaLabelledBy="deletedMobileLabel"
            (onChange)="
              onPrimeFilterChangeMobile($event.value, 'usuniety')
            "
            [options]="deletedOptions"
            [showClear]="true"
            [(ngModel)]="tableFilters.usuniety"
            optionLabel="label"
            optionValue="value"
            placeholder="Wybierz wartość"
            appendTo="body"
            class="w-full"
          ></p-select>
        </div>
      </div>

      <div class="flex flex-row-reverse mt-4">
        <p-button
          type="button"
          label="Wyczyść filtry"
          styleClass="customInfoButton outlined"
          (click)="resetAllFilters()"
        />
      </div>
    </p-card>

    <div class="flex flex-col gap-4">
      @for (applicationForm of rows(); track applicationForm.id) {
        <p-card class="customMobileCard">
          <div class="flex flex-col">
            <app-preview-data-wrapper
              label="Kod wniosku"
              [data]="applicationForm.kod"
              [additionalCssClasses]="'font-bold'"
            ></app-preview-data-wrapper>
            <hr class="limiter" />
            <app-preview-data-wrapper
              label="Nazwa"
              [data]="applicationForm.nazwa"
              [additionalCssClasses]="'font-bold'"
            ></app-preview-data-wrapper>
            <hr class="limiter" />
            <app-preview-data-wrapper
              label="Obszar"
              [data]="
                applicationForm.grupa
                  | constLabelReader: APPLICATION_GROUP_LABELS
              "
              [additionalCssClasses]="'font-bold'"
            ></app-preview-data-wrapper>
            <hr class="limiter" />
            <app-preview-data-wrapper
              label="Wniosek usunięty"
              [data]="getBooleanLabel(applicationForm.usuniety)"
              [additionalCssClasses]="'font-bold'"
            ></app-preview-data-wrapper>

            <div class="flex justify-end mt-5">
              <p-button
                (click)="showDetails(applicationForm)"
                label="Podgląd"
                styleClass="customInfoButton outlined"
              />
            </div>
          </div>
        </p-card>
      } @empty {
        <p-card>
          <span>Brak danych</span>
        </p-card>
      }
    </div>

    <div class="mt-4 flex justify-end">
      <div class="text-sm">
        <span>
          Strona {{ (tablePage()?.number || 0) + 1 }} z
          {{ tablePage()?.totalPages || 0 }}
        </span>
      </div>
    </div>
    <p-paginator
      (onPageChange)="onPrimePageChange($event)"
      [pageLinkSize]="3"
      [rowsPerPageOptions]="[5, 10, 25]"
      [rows]="tablePage()?.size || 10"
      [totalRecords]="tablePage()?.totalElements || 0"
      class="mt-2"
    />
  </div>
</div>
